var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#f6f6f6","height":"100vh"}},[(_vm.loader)?[_c('Loader')]:_vm._e(),_c('div',[_vm._v("teste")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }